export const GET_ALL_SEARCH = 'GET_ALL_SEARCH'
export const GET_SINGLE_CART = 'GET_SINGLE_CART'
export const GET_AVAILABLE_APPOINT = 'GET_AVAILABLE_APPOINT'

export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
